import React from "react";
import { DataGrid, GridColDef, GridCellParams, GridRowParams, GridValueFormatterParams, GridValueGetterParams, GridSortModel, deDE, LocalizationV4 } from "@material-ui/data-grid";
import Tooltip from '@material-ui/core/Tooltip';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {
    Container
} from "@material-ui/core";
import { useAppSelector, useAppDispatch } from '../../../app/hooks'
import {
    selectMessgeraete,
    selectMessgeraetetyp,
    updateAktuellesMessgeraet,
    messgeraetDummy,
    selectListLoading,
    setSorting,
    selectSorting
} from "./messgeraeteSlice";
import { useStyles } from "./messgeraeteStyles";
import { messgeraet, messgeraettyp } from "../../../utils/apiTypes";
import { globalStyles } from "../../../assets/globalStyles";
import { alphaNumSort } from "../../../utils/utils";


export const MessgeraeteGrid: React.FC = () => {
    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const rows: messgeraet[] = useAppSelector(selectMessgeraete),
        messgeraettypSelectList: messgeraettyp[] = useAppSelector(selectMessgeraetetyp),
        listLoading: boolean = useAppSelector(selectListLoading),
        sorting: GridSortModel = useAppSelector(selectSorting);



    const dataGridCols2: GridColDef[] = [
        {
            field: 'status', headerName: ' ', flex: 0.2, align: "center", renderCell: function status(params: GridCellParams) {
                return (<React.Fragment>
                    {params.getValue(params.id, 'zugeordnet') ?
                        <Tooltip title="Aktivem Messpunkt zugeordnet">
                            <FiberManualRecordIcon color="secondary" />
                        </Tooltip>
                        : (params.getValue(params.id, 'jemalsZugeordnet') ?
                            <Tooltip title="Aktivem Messpunkt zugeordnet gewesen">
                                <FiberManualRecordOutlinedIcon color="secondary" />
                            </Tooltip>
                            : "")}</React.Fragment>)
            },
            sortComparator: (v1, v2, param1, param2) => {
                const p1 = param1.api.getCellValue(param1.id, 'zugeordnet') ? 2 : param1.api.getCellValue(param1.id, 'jemalsZugeordnet') ? 1 : 0;
                const p2 = param1.api.getCellValue(param2.id, 'zugeordnet') ? 2 : param1.api.getCellValue(param2.id, 'jemalsZugeordnet') ? 1 : 0;
                return p2 - p1;
            }, filterable: false
        },
        { field: 'seriennummer', headerName: 'Seriennummer', flex: 0.8, sortComparator: alphaNumSort },
        { field: 'herstellungsjahr', headerName: 'Herstellungsjahr', flex: 0.8 },
        { field: 'firmware', headerName: 'Firmware', flex: 0.8, sortComparator: alphaNumSort },
        { field: 'macadresse', headerName: 'MAC Adresse', flex: 0.8, sortComparator: alphaNumSort },
        {
            field: 'inbetriebnahmedatum', headerName: 'Inbetriebnahmedatum', flex: 1, valueFormatter: (params: GridValueFormatterParams) => {
                const inbetriebnahmedatumO = params.getValue(params.id, 'inbetriebnahmedatum');
                if (inbetriebnahmedatumO === null)
                    return "";
                const dateConvert = new Date(inbetriebnahmedatumO ? inbetriebnahmedatumO.toString() : "");
                return (dateConvert).toLocaleDateString('de-DE')
            }, filterable: false
        },
        { field: 'wartungsintervall', headerName: 'Wartungsintervall', flex: 1, sortComparator: alphaNumSort },
        { field: 'zeitsynchronisationsart', headerName: 'Zeitsynchronisationsart', flex: 1 },
        {
            field: 'hersteller', headerName: 'Hersteller', flex: 0.8, valueGetter: (params: GridValueGetterParams) => {
                return messgeraettypSelectList.length == 0 ? "Wird geladen..." : (messgeraettypSelectList.find((x: messgeraettyp) => x.id == params.getValue(params.id, 'typ'))?.hersteller);
            }
        },
        {
            field: 'messgeraettyp', headerName: 'Typ', flex: 0.8, valueGetter: (params: GridValueGetterParams) => {
                return messgeraettypSelectList.length == 0 ? "Wird geladen..." : (messgeraettypSelectList.find((x: messgeraettyp) => x.id == params.getValue(params.id, 'typ'))?.typ);
            }
        },
        { field: 'ipadresse', headerName: 'IP-Adresse', flex: 0.8, sortComparator: alphaNumSort },
        { field: 'subnetzmaske', headerName: 'Subnetzmaske', flex: 0.8, sortComparator: alphaNumSort }
    ]


    return (
        <Container maxWidth={false} className={classes.root}>
            <div style={{ height: "50vh", width: '100%' }}>
                <DataGrid
                    localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                    disableColumnMenu={false}
                    disableColumnSelector={true}
                    columns={dataGridCols2}
                    rows={rows}
                    sortModel={sorting}
                    onSortModelChange={(model) => setSorting(model.sortModel)}
                    onRowClick={(param: GridRowParams) => {
                        let mt = messgeraetDummy;
                        const temp = rows.find(mst => mst.id == (param.row.id as number))
                        if (temp)
                            mt = temp;
                        dispatch(updateAktuellesMessgeraet(mt));
                    }} loading={listLoading} />
            </div>
        </Container>
    );
}